import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const ClientPagination = ({
  currentPage,
  totalPages,
  paginate,
  filteredClients,
  clientsPerPage,
  indexOfFirstClient,
  indexOfLastClient,
}) => (
  <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
    <p className="text-sm text-gray-500 dark:text-gray-400">
      Showing{' '}
      <span className="font-medium text-gray-900 dark:text-white">{indexOfFirstClient + 1}</span> to{' '}
      <span className="font-medium text-gray-900 dark:text-white">
        {Math.min(indexOfLastClient, filteredClients.length)}
      </span>{' '}
      of <span className="font-medium text-gray-900 dark:text-white">{filteredClients.length}</span> clients
    </p>

    {filteredClients.length > clientsPerPage && (
      <div className="flex items-center gap-1">
        <button
          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : currentPage)}
          disabled={currentPage === 1}
          className={`p-2 rounded-lg transition-all ${
            currentPage === 1
              ? 'text-gray-300 dark:text-neutral-700 cursor-not-allowed'
              : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-neutral-800'
          }`}
        >
          <FaChevronLeft className="w-4 h-4" />
        </button>

        {Array.from({ length: totalPages }, (_, i) => {
          if (i === 0 || i === totalPages - 1 || (i >= currentPage - 2 && i <= currentPage + 2)) {
            return (
              <button
                key={i + 1}
                onClick={() => paginate(i + 1)}
                className={`min-w-[36px] h-9 px-3 rounded-lg text-sm font-medium transition-all ${
                  i + 1 === currentPage
                    ? 'bg-primary-600 text-white shadow-lg'
                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-neutral-800'
                }`}
              >
                {i + 1}
              </button>
            );
          }
          if (i === currentPage - 3 || i === currentPage + 3) {
            return (
              <span key={i} className="px-2 text-gray-400">
                ...
              </span>
            );
          }
          return null;
        })}

        <button
          onClick={() => paginate(currentPage < totalPages ? currentPage + 1 : currentPage)}
          disabled={currentPage === totalPages}
          className={`p-2 rounded-lg transition-all ${
            currentPage === totalPages
              ? 'text-gray-300 dark:text-neutral-700 cursor-not-allowed'
              : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-neutral-800'
          }`}
        >
          <FaChevronRight className="w-4 h-4" />
        </button>
      </div>
    )}
  </div>
);

export default ClientPagination;
